'use strict';

export default {
  'history-and-culture': 'culture',
  'pick-up-and-driving': 'driving',
  'food-and-restaurant': 'food',
  'art-and-museums': 'museums',
  'nightlife-and-bars': 'nightlife',
  'sports-and-recreation': 'recreation',
  'exploration-and-sightseeing': 'sightseeing',
  'translation-and-interpretation': 'translation',
  'shopping': 'shopping',
};



// WEBPACK FOOTER //
// ./app/src/constants/seo_activities.js